// Help Center links (ED-2559). The Crisp KB at help.eleplan.com is retired;
// the owned Help Center lives at eleplan.com/help, backed by the help_articles
// table and managed from the admin console. ALL in-app help links go through
// this helper so the next move is a one-line change.

const HELP_BASE = 'https://eleplan.com/help';

/** Public URL for a help article, e.g. helpArticleUrl('medication-opt-in'). */
export function helpArticleUrl(slug: string): string {
  return `${HELP_BASE}/${encodeURIComponent(slug)}`;
}

/** The Help Center index. */
export function helpCenterUrl(): string {
  return HELP_BASE;
}
